import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propShape, propFunc, propOneOf, propBool, propStr, } from '../../../../../helpers/custom-prop-types';
import ProfessionalUnitProjectCareerMiddleTasks from '../../Parts/ProfessionalUnitProjectCareerMiddleTasks';
import ProfessionalUnitProjectCareerProfessionals from '../../Parts/ProfessionalUnitProjectCareerProfessionals';
import ProfessionalUnitProjectCareerTitle from '../../Parts/ProfessionalUnitProjectCareerTitle';
import ProfessionalUnitProjectCareerContent from './ProfessionalUnitProjectCareerContent';
import ProfessionalUnitProjectCareerContentLock from './ProfessionalUnitProjectCareerContentLock';
const ProfessionalUnitProjectCareer = (props) => {
    const { isHidden, itemClassName, onClickReadMore, projectCareer, showAlertModal, userMode, } = props;
    const { content, id, middleTasks, professionals, title } = projectCareer;
    const isPre = userMode === 'pre';
    const isViewable = userMode === 'view';
    return (_jsxs("div", Object.assign({ className: clsx('unit_project_career', itemClassName) }, { children: [_jsx(ProfessionalUnitProjectCareerTitle, { title: title }), _jsxs("div", Object.assign({ className: 'header_row' }, { children: [_jsx(ProfessionalUnitProjectCareerMiddleTasks, { middleTasks: middleTasks }), _jsx(ProfessionalUnitProjectCareerProfessionals, { professionals: professionals, showAlertModal: showAlertModal, userMode: userMode })] })), isViewable || isPre ? (_jsx(ProfessionalUnitProjectCareerContent, { content: content, id: id, isHidden: isHidden, onClickReadMore: isPre ? showAlertModal : onClickReadMore })) : (_jsx(ProfessionalUnitProjectCareerContentLock, { showAlertModal: showAlertModal, userMode: userMode }))] })));
};
ProfessionalUnitProjectCareer.propTypes = {
    isHidden: propBool().isRequired,
    itemClassName: propStr(),
    onClickReadMore: propFunc().isRequired,
    projectCareer: propShape().isRequired,
    showAlertModal: propFunc().isRequired,
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
ProfessionalUnitProjectCareer.defaultProps = {
    itemClassName: '',
};
export default ProfessionalUnitProjectCareer;
